<template>
  <div style="width: 100%; height: 100%">
    <div class="linkageList">
      <div class="container">
        <div>
          <span>{{ $t('linkage.title') }}</span>
        </div>
        <div>
          <a-space>
            <a-button
              type="primary"
              v-if="authorities.find(a => a.code === 'device:manage:linkage:query')"
              @click="handleSearch"
            >
              {{ $t('buttons.search') }}
            </a-button>
            <a-button
              key="submit"
              type="primary"
              v-if="authorities.find(a => a.code === 'device:manage:linkage:insert')"
              @click="$router.push('/equipment/linkage/submit')"
            >
              {{ $t('buttons.add') }}
            </a-button>
          </a-space>
        </div>
      </div>
      <div style="background-color: #fff; margin-top: 10px; position: relative">
        <div v-show="loading" style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(255, 255, 255, .6); z-index: 1000; display: flex; justify-content: center; align-items: center">
          <a-spin />
        </div>
        <el-table
          stripe
          style="width: 100%"
          :header-cell-style="{ backgroundColor: '#fafafa' }"
          :data="linkageList"
        >
          <el-table-column
            prop="groupCode"
            label="联控组编码"
          >
            <template #header>
              <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('linkage.groupCode') }}<span class="icons unset" style="cursor: pointer;" data-index="0">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span></div>
              <a-input v-model="queryParams.query[0].value" allow-clear @keyup.enter="handleSearch" />
            </template>
            <template slot-scope="scope">
              <text-highlight :queries="highLightInfo.groupCode">{{ scope.row.groupCode }}</text-highlight>
            </template>
          </el-table-column>
          <el-table-column
            prop="groupName"
            label="联控组名称"
          >
            <template #header>
              <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('linkage.groupName') }}<span class="icons unset" style="cursor: pointer;" data-index="0">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span></div>
              <a-input v-model="queryParams.query[1].value" allow-clear @keyup.enter="handleSearch" />
            </template>
            <template slot-scope="scope">
              <text-highlight :queries="highLightInfo.groupName">{{ scope.row.groupName }}</text-highlight>
            </template>
          </el-table-column>
          <el-table-column
            prop="enabled"
            label="是否启用"
          >
            <template #header>
              <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('linkage.enabled') }}</div>
              <a-select style="width: 100%" v-model="enabled" @change="handleSearch">
                <a-select-option :value="1">
                  {{ $t('common.all') }}
                </a-select-option>
                <a-select-option :value="2">
                  {{ $t('common.yes') }}
                </a-select-option>
                <a-select-option :value="3">
                  {{ $t('common.no') }}
                </a-select-option>
              </a-select>
            </template>
            <template slot-scope="scope">
              {{ scope.row.enabled ? $t('common.yes') : $t('common.no') }}
            </template>
          </el-table-column>
          <el-table-column
            prop="createdAt"
            label="创建时间"
          >
            <template #header>
              <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('linkage.createdAt') }}<span class="icons unset" style="cursor: pointer;" data-index="0">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span></div>
            </template>
          </el-table-column>
          <el-table-column
            prop="updatedAt"
            label="更新时间"
          >
            <template #header>
              <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('linkage.updatedAt') }}<span class="icons DESC" style="cursor: pointer;" data-index="1">
                <a-icon type="caret-up" />
                <a-icon type="caret-down" />
              </span></div>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
          >
            <template #header>
              <div style="color: rgba(0, 0, 0, 0.85); font-weight: 500; text-align: left;">{{ $t('common.operation') }}</div>
            </template>
            <template slot-scope="scope">
              <a-button
                style="padding-left: 0"
                type="link"
                v-show="authorities.find(a => a.code === 'device:manage:linkage:update')"
                @click="onEdit(scope.row)"
              >
                {{ $t('buttons.edit') }}
              </a-button>
              <a-popconfirm
                :title="$t('messages.ctrd')"
                :ok-text="$t('common.okText')"
                :cancel-text="$t('common.cancelText')"
                @confirm="onDelete(scope.row)"
              >
                <a-button
                  style="padding-left: 0"
                  type="link"
                  v-show="authorities.find(a => a.code === 'device:manage:linkage:delete')"
                >
                  {{ $t('buttons.delete') }}
                </a-button>
              </a-popconfirm>
            </template>
          </el-table-column>
        </el-table>
        <a-pagination
          style="float: right; margin-top: 20px; padding-bottom: 20px"
          :current="pagination.current"
          :total="pagination.total"
          @change="handlePageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import en from 'element-ui/lib/locale/lang/en'
import zh from 'element-ui/lib/locale/lang/zh-CN'
import locale from 'element-ui/lib/locale'
import TextHighlight from "vue-text-highlight"
import moment from 'moment'
import { getLinkages, deleteLinkage } from '@/api/linkage'

export default {
  components: {
    TextHighlight
  },
  data() {
    return {
      authorities: [],
      loading: false,
      en,
      zh,
      queryParams: {
        query: [
          {
            field: 'groupCode',
            value: ''
          },
          {
            field: 'groupName',
            value: ''
          }
        ],
        filter: [],
        sort: [
          {
            field: 'updatedAt',
            value: 'DESC'
          },
          {
            field: 'createdAt',
            value: ''
          }
        ]
      },
      highLightInfo: {},
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      enabled: 1,
      linkageList: []
    }
  },
  computed: {
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang(v) {
      locale.use(this[v])
    }
  },
  created() {
    locale.use(this[this.lang])
    const a = JSON.parse(sessionStorage.getItem('authorities'))
    if (a?.length) {
      this.authorities = a
    } else {
      this.authorities = this.getAuthorities(this.$route.path)
    }
    this.queryParams.query.forEach(q => {
      this.highLightInfo[q.field] = q.value
    })
  },
  activated() {
    if (this.$store.state.linkageFlag) {
      this.getLinkageList()
      this.$store.commit('setLinkageFlag', false)
    }
  },
  mounted() {
    this.getLinkageList()
    this.$nextTick(() => {
      const ss = document.querySelectorAll(".linkageList span.icons");
      ss.forEach(i => {
        i.addEventListener("click", () => {
          let c = "";
          switch (i.classList[1]) {
            case "ASC":
              c = "DESC";
              break;
            case "DESC":
              c = "unset";
              break;
            case "unset":
              c = "ASC";
              break;
            default:
              break;
          }
          i.classList.remove(i.classList[1]);
          i.classList.add(c);
          // const ii = document.querySelectorAll(
          //   "div span.icons:not(.unset)"
          // );
          // console.log(ii);
          const index = +i.dataset["index"];
          if (i.classList[1] === "unset") {}
          this.queryParams.sort[index].value = i.classList[1] === 'unset' ? '' : i.classList[1]
          this.getLinkageList()
        });
      });
    })
  },
  methods: {
    async getLinkageList() {
      this.loading = true
      try {
        const { data } = await getLinkages(this.pagination.current, this.pagination.pageSize, this.queryParams)
        this.linkageList = data.records.map(r => {
          r.createdAt = moment(+new Date(r.createdAt)).format('YYYY-MM-DD HH:mm:ss')
          r.updatedAt = moment(+new Date(r.updatedAt)).format('YYYY-MM-DD HH:mm:ss')
          return r
        })
        this.pagination.current = data.current,
        this.pagination.total = data.total
        this.queryParams.query.forEach(q => {
          this.highLightInfo[q.field] = q.value
        })
      } catch(e) {
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    handleSearch() {
      this.pagination.current = 1
      this.queryParams.filter = []
      if (this.enabled > 1) {
        this.queryParams.filter[0] = {
          field: 'enabled',
          value: this.enabled === 2
        }
      } else {
        this.queryParams.filter = []
      }
      this.getLinkageList()
    },
    onEdit(r) {
      this.$router.push({ path: '/equipment/linkage/submit', query: { id: r.id } })
    },
    handlePageChange(current) {
      this.pagination.current = current
      this.getLinkageList()
    },
    async onDelete(r) {
      try {
        const { message } = await deleteLinkage(r.id)
        this.$message.success(message)
        this.getLinkageList()
      } catch(e) {
        console.log(e)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.linkageList {
  padding: 15px;
  width: 100%;
  height: 100%;
}
.linkageList .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  font-size: 20px;
}
span {
  position: relative;
}
.anticon-caret-up {
  position: absolute;
  top: -1px;
  right: 0px;
  font-size: 14px;
  color: #ccc;
}
span.ASC .anticon-caret-up {
  color: #1890ff;
}
span.icons {
  position: absolute;
  right: 18px;
}
span.DESC .anticon-caret-down {
  color: #1890ff;
}
.anticon-caret-down {
  position: absolute;
  top: 8px;
  right: 0px;
  font-size: 14px;
  color: #ccc;
}
/deep/ .ant-select-selection__rendered {
  font-weight: normal;
}
</style>
